import { Card } from 'antd';
import { memo } from 'react';
import no_data from '../../../assets/no-data-icn.png';
import { Translate } from '../index';

function NoDataCard() {
  return (
    <Card
      style={{
        // minHeight: 'calc(100vh - 210px)',
        height: '300',
      }}
      className="flex items-center justify-center"
    >
      <img
        width={350}
        className="md:block hidden m-auto"
        src={no_data}
        alt="no_data"
      />
      <h1 className="font-bold text-center text-4xl m-auto text-gray-500">
        <Translate
          en="Oops! We could not find anything to show."
          bn="দুঃখিত ! আমরা দেখানোর জন্য কিছু খুঁজে পাইনি ।"
        />
      </h1>
    </Card>
  );
}

export default memo(NoDataCard);
